import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { useTheme, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { WithdrawalDetails } from "../../types";
import CardText from "../CardText";

type Props = {
  summary: WithdrawalDetails["summary"];
};

export default function DepositSummary({ summary }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  const textVariantStyle = { color: colors.onSurfaceVariant };

  const { amount, currency, period } = summary;

  return (
    <View style={tailwind("mx-4")}>
      <View style={tailwind("flex-row justify-between")}>
        <View>
          <Text variant="bodyLarge">Monto de depósito</Text>
          <CardText.Subtitle
            text="Periodo de ventas"
            style={tailwind("my-1")}
          />
        </View>
        <Text variant="headlineSmall" style={textVariantStyle}>
          {amountAsCurrency({ amount, currency })}
        </Text>
      </View>

      <CardText.Body text={period} style={tailwind("mb-1")} />
    </View>
  );
}
